(function () {
    'use strict';
    var controllerId = 'cndPCorsoAdd2A';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '_', 'datacontext', 'apl', 'isSuper', fn_cndPCorsoAdd2A]);

    function fn_cndPCorsoAdd2A($scope, $uibModalInstance, _, datacontext, apl, isSuper) {
        $scope.record = {};
        $scope.apl = apl;
        $scope.isSuper = isSuper;
        $scope.record.TMisuraCode = '2A';

        $scope.percorsiFormativi = [
            { Id: 1, Name: 'COMPETENZE INFORMATICHE' }
            , { Id: 2, Name: 'COMPETENZE LINGUISTICHE' }
        ];

        $scope.changeTitolo = function (text) {
            $scope.record.Titolo = '';
            switch (text) {
                case 'COMPETENZE INFORMATICHE':
                    $scope.record.Titolo = '[INF] ';
                    break;
                case 'COMPETENZE LINGUISTICHE':
                    $scope.record.Titolo = '[LING] ';
                    break;

            }

            return $scope.record.Titolo;
        };

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.pCorso_add(item).then(function (data) {
                return data;
            });
        }
    }
})();